import type { ReactNode } from 'react';

import Text from '@cartwhl/ui/base/Text';

import { PANEL_WRITING_CLASSNAME } from '../../../presentations/panelWritingStyle';

interface RowProps {
  label: string;
  value: ReactNode;
}

export default function Row({ label, value }: RowProps) {
  return (
    <div className="flex items-baseline justify-between gap-2 py-1">
      <Text
        variant="studio/body/medium/xs"
        className={`${PANEL_WRITING_CLASSNAME} shrink-0`}
      >
        {label}
      </Text>
      <Text
        variant="studio/body/medium/xs"
        className={`truncate text-right ${PANEL_WRITING_CLASSNAME}`}
      >
        {value}
      </Text>
    </div>
  );
}
